/**
 * セットアップユーザーのストアスライス
 */
import { createSlice } from '@reduxjs/toolkit';

export interface setupUserType {
  id: string;
  nickname: string;
  email: string;
  invitationCode: string;
  inviter: string;
  stripeCardTokenId: string;
  responseText: string;
  responseVoiceType: number;
  responseS3Id: string;
  addMessage: number;
  inMessage: number;
  attachMedia: number;
  incomingNotice: number;
  userNumber: string;
  serviceNumber: string;
  userStatus: number;
  token: string;
}

export const setupUserSlice = createSlice({
  name: 'setupUser',
  initialState: {
    id: '',
    nickname: '',
    email: '',
    invitationCode: '',
    inviter: '',
    stripeCardTokenId: '',
    responseText:
      '只今、電話に出ることができません。お手数ですが、発信音の後に30秒以内でメッセージをお願いいたします。',
    responseVoiceType: 0,
    responseS3Id: '',
    addMessage: 1,
    inMessage: 1,
    attachMedia: 1,
    incomingNotice: 1,
    userNumber: '',
    serviceNumber: '',
    userStatus: 0,
    token: '',
  },
  reducers: {
    setId: (state, action) => {
      state.id = action.payload;
    },
    setNickname: (state, action) => {
      state.nickname = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setInvitationCode: (state, action) => {
      state.invitationCode = action.payload;
    },
    setInviter: (state, action) => {
      state.inviter = action.payload;
    },
    setStripeCardTokenId: (state, action) => {
      state.stripeCardTokenId = action.payload;
    },
    setResponseText: (state, action) => {
      state.responseText = action.payload;
    },
    setResponseVoiceType: (state, action) => {
      state.responseVoiceType = action.payload;
    },
    setResponseS3Id: (state, action) => {
      state.responseS3Id = action.payload;
    },
    setAddMessage: (state, action) => {
      state.addMessage = action.payload;
    },
    setInMessage: (state, action) => {
      state.inMessage = action.payload;
    },
    setAttachMedia: (state, action) => {
      state.attachMedia = action.payload;
    },
    setIncomingNotice: (state, action) => {
      state.incomingNotice = action.payload;
    },
    setUserNumber: (state, action) => {
      state.userNumber = action.payload;
    },
    setServiceNumber: (state, action) => {
      state.serviceNumber = action.payload;
    },
    setUserStatus: (state, action) => {
      state.userStatus = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const {
  setId,
  setNickname,
  setEmail,
  setInvitationCode,
  setInviter,
  setStripeCardTokenId,
  setResponseText,
  setResponseVoiceType,
  setResponseS3Id,
  setAddMessage,
  setInMessage,
  setAttachMedia,
  setIncomingNotice,
  setUserNumber,
  setServiceNumber,
  setUserStatus,
  setToken,
} = setupUserSlice.actions;
export default setupUserSlice.reducer;
